export default "__VITE_ASSET__DomSC0qH__"